/** Schema for various Resume Builder steps */

export const TOTAL_STEPS = 11;

export const STEP_INDICES = {
  LANDING: 0,
  EXPERIENCE_LEVEL: 1,
  TEMPLATE_GALLERY: 2,
  CONTACT: 3,
  WORK_HISTORY: 4,
  EDUCATION: 5,
  SKILLS: 6,
  INTERESTS: 7,
  SUMMARY: 8,
  SIGNUP: 9,
  FINISH: 10,
};

export const LANDING_STEP = {
  index: STEP_INDICES.LANDING,
  subSteps: {
    0: {
      index: 0,
      url: '',
    },
  },
  data: {},
};

export const EXPERIENCE_LEVEL_STEP = {
  index: STEP_INDICES.EXPERIENCE_LEVEL,
  subSteps: {
    0: {
      index: 0,
      title: 'How Much Work Experience Do You Have?',
      url: 'job-level',
      pageTitle: 'Years of Experience - Zippia',
    },
  },
  data: {},
};

export const TEMPLATE_GALLERY_STEP = {
  index: STEP_INDICES.TEMPLATE_GALLERY,
  btnLabel: 'Resume Template',
  subSteps: {
    0: {
      index: 0,
      title: 'Choose A Custom Resume Template',
      url: 'choose-template',
      pageTitle: '10+ Professional Resume Templates - Zippia',
    },
  },
  data: {},
};

export const CONTACTS_STEP = {
  index: STEP_INDICES.CONTACT,
  btnLabel: 'Contact Info',
  navLabel: 'Contacts Info',
  subSteps: {
    0: {
      index: 0,
      title: 'Enter Your Contact Info',
      url: 'contacts',
      pageTitle: 'Contact Info - Zippia',
    },
  },
  data: {},
  errorFields: {},
};

export const SUMMARY_STEP = {
  index: STEP_INDICES.SUMMARY,
  btnLabel: 'Summary',
  navLabel: 'Summary',
  subSteps: {
    0: {
      index: 0,
      title: 'Write Your Summary',
      url: 'summary-info',
      pageTitle: 'Summary Tips - Zippia',
    },
  },
  data: {},
};

export const WORK_HISTORY_STEP = {
  index: STEP_INDICES.WORK_HISTORY,
  btnLabel: 'Work History',
  navLabel: 'Work History',
  subSteps: {
    0: {
      index: 0,
      title: 'Enter Your Work History',
      url: 'employer-info',
      pageTitle: 'Work History - Zippia',
    },
    1: {
      index: 1,
      url: 'tasks-performed',
      pageTitle: 'Work History Tips - Zippia',
    },
    2: {
      index: 2,
      title: 'Your Work History',
      url: 'add-additional-experience',
      pageTitle: 'Work History - Zippia',
    },
  },
  data: {},
  errorFields: {},
};

export const SIGNUP_STEP = {
  index: STEP_INDICES.SIGNUP,
  subSteps: {
    0: {
      index: 0,
      url: 'sign-up',
      pageTitle: 'Resume Sign-up - Zippia',
    },
  },
};

export const EDUCATION_STEP = {
  index: STEP_INDICES.EDUCATION,
  btnLabel: 'Education',
  navLabel: 'Education',
  subSteps: {
    0: {
      index: 0,
      title: 'Choose Your Highest Level Of Education',
      url: 'education-level',
      pageTitle: 'Education Level - Zippia',
    },
    1: {
      index: 1,
      title: 'Tell Us About Your Education',
      url: 'education-info',
      pageTitle: 'Education Info - Zippia',
    },
    2: {
      index: 2,
      title: 'Your Education',
      url: 'add-additional-education',
      pageTitle: 'Education Info - Zippia',
    },
  },
  data: {},
  errorFields: {},
};

export const SKILLS_STEP = {
  index: STEP_INDICES.SKILLS,
  btnLabel: 'Skills',
  navLabel: 'Skills',
  subSteps: {
    0: {
      index: 0,
      title: 'Select Your Skills',
      url: 'add-skills',
      pageTitle: 'Add Skills - Zippia',
    },
  },
  data: {},
};

export const INTERESTS_STEP = {
  index: STEP_INDICES.INTERESTS,
  btnLabel: 'Interests',
  navLabel: 'Interests',
  subSteps: {
    0: {
      index: 0,
      title: 'Add Additional Sections To Your Resume',
      url: 'interest-intro',
      pageTitle: 'Interest Tips - Zippia',
    },
    1: {
      index: 1,
      title: 'What Certifications Do You Have?',
      url: 'certification-info',
      pageTitle: 'Add Certifications - Zippia',
    },
    2: {
      index: 2,
      title: 'Your Languages',
      url: 'language-info',
      pageTitle: 'Add Languages - Zippia',
    },
  },
  data: {
    customSections: {},
  },
};

export const FINISH_STEP = {
  index: STEP_INDICES.FINISH,
  btnLabel: 'Finish',
  navLabel: 'Finish',
  hideBack: true,
  subSteps: {
    0: {
      index: 0,
      title: 'Finish',
      url: 'resume-finish',
      pageTitle: 'Finalize Resume - Zippia',
    },
  },
};

// Schema of all Steps = 11 steps
export const ResumeBuilderSchema = {
  [STEP_INDICES.LANDING]: LANDING_STEP,
  [STEP_INDICES.EXPERIENCE_LEVEL]: EXPERIENCE_LEVEL_STEP,
  [STEP_INDICES.TEMPLATE_GALLERY]: TEMPLATE_GALLERY_STEP,
  [STEP_INDICES.CONTACT]: CONTACTS_STEP,
  [STEP_INDICES.WORK_HISTORY]: WORK_HISTORY_STEP,
  [STEP_INDICES.EDUCATION]: EDUCATION_STEP,
  [STEP_INDICES.SKILLS]: SKILLS_STEP,
  [STEP_INDICES.INTERESTS]: INTERESTS_STEP,
  [STEP_INDICES.SUMMARY]: SUMMARY_STEP,
  [STEP_INDICES.SIGNUP]: SIGNUP_STEP,
  [STEP_INDICES.FINISH]: FINISH_STEP,
};
